import { render, staticRenderFns } from "./MemberListComponent.vue?vue&type=template&id=38395a74&scoped=true&"
import script from "./MemberListComponent.vue?vue&type=script&lang=js&"
export * from "./MemberListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38395a74",
  null
  
)

export default component.exports